interface TokenLimitDialogProps {
  isOpen: boolean
  refreshTime: number | null
  onClose: () => void
}

function formatRefreshDate(epochSeconds: number | null): string {
  if (!epochSeconds) return 'soon'
  return new Date(epochSeconds * 1000).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export default function TokenLimitDialog({ isOpen, refreshTime, onClose }: TokenLimitDialogProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="flex min-h-full items-center justify-center p-4">
        <div data-testid="token-limit-dialog" className="relative bg-white rounded-xl shadow-xl max-w-sm w-full p-6">
          {/* Icon */}
          <div className="flex items-center justify-center w-12 h-12 bg-amber-100 rounded-full mx-auto mb-4">
            <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">
            AI Token Limit Reached
          </h3>

          <p className="text-sm text-gray-600 text-center mb-2">
            You've used all your AI tokens for this period.
          </p>

          {refreshTime && (
            <p className="text-sm text-gray-600 text-center mb-4">
              Your tokens will refresh on{' '}
              <span className="font-semibold text-gray-900">
                {formatRefreshDate(refreshTime)}
              </span>
              .
            </p>
          )}

          <div className="flex flex-col gap-2">
            <a
              href="/subscription"
              className="w-full py-2.5 px-4 bg-primary text-white rounded-lg hover:bg-secondary transition-colors text-sm font-medium text-center"
              onClick={onClose}
            >
              Upgrade Plan
            </a>
            <button
              data-testid="token-limit-close"
              onClick={onClose}
              className="w-full py-2.5 px-4 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

